/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../features/attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationMemberRowFragment = { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, jobTitle: string, membershipStatus: Types.OrganisationMembershipStatus, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string }>, phones: Array<{ __typename: 'Phone', number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, membershipInvitation?: { __typename: 'OrganisationMembershipInvitation', id: string, status: Types.OrganisationMembershipInvitationStatus } | null };

export type OrganisationMembers_OrganisationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationMembers_OrganisationQuery = { viewer?: { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, title: string, representive?: { __typename: 'User', id: string } | null, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }> } } | null };

export type OrganisationMembers_MembershipsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
  sorting: Array<Types.OrganisationMembershipsSorting>;
  filters?: Types.InputMaybe<Types.OrganisationMembershipsFilters>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OrganisationMembers_MembershipsQuery = { organisationMemberships: { __typename: 'OrganisationMembershipsConnection', totalCount: number, edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, jobTitle: string, membershipStatus: Types.OrganisationMembershipStatus, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string }>, phones: Array<{ __typename: 'Phone', number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, membershipInvitation?: { __typename: 'OrganisationMembershipInvitation', id: string, status: Types.OrganisationMembershipInvitationStatus } | null } }> } };

export type OrganisationMembers_CreateNewOrganisationMemberMutationVariables = Types.Exact<{
  input: Types.CreateSystemUserInput;
}>;


export type OrganisationMembers_CreateNewOrganisationMemberMutation = { createSystemUser: { __typename: 'CreateSystemUserResult', user: { __typename: 'User', id: string, firstname: string, familyname: string, email: any, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string }> } } };

export type OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationVariables = Types.Exact<{
  organisationId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
}>;


export type OrganisationMembers_SetMemberAsOrganisationRepresentativeMutation = { setOrganisationRepresentative: { __typename: 'SetOrganisationRepresentativeResult', organisation: { __typename: 'ViewerOrganisation', id: string, representive?: { __typename: 'User', id: string } | null } } };

export const OrganisationMemberRowFragmentDoc = gql`
    fragment OrganisationMemberRow on User {
  id
  firstname
  familyname
  fullname
  email
  jobTitle
  roles {
    id
    internalName
  }
  phones {
    number
  }
  avatar {
    ...AttachmentSnapshot
  }
  membershipStatus
  membershipInvitation {
    id
    status
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const OrganisationMembers_OrganisationDocument = gql`
    query OrganisationMembers_Organisation {
  viewer {
    id
    organisation {
      id
      id
      title
      representive {
        id
      }
      roles {
        id
        internalName
        label
      }
    }
  }
}
    `;

/**
 * __useOrganisationMembers_OrganisationQuery__
 *
 * To run a query within a React component, call `useOrganisationMembers_OrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMembers_OrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationMembers_OrganisationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationMembers_OrganisationQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationMembers_OrganisationQuery, OrganisationMembers_OrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationMembers_OrganisationQuery, OrganisationMembers_OrganisationQueryVariables>(OrganisationMembers_OrganisationDocument, options);
      }
export function useOrganisationMembers_OrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationMembers_OrganisationQuery, OrganisationMembers_OrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationMembers_OrganisationQuery, OrganisationMembers_OrganisationQueryVariables>(OrganisationMembers_OrganisationDocument, options);
        }
export function useOrganisationMembers_OrganisationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationMembers_OrganisationQuery, OrganisationMembers_OrganisationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationMembers_OrganisationQuery, OrganisationMembers_OrganisationQueryVariables>(OrganisationMembers_OrganisationDocument, options);
        }
export type OrganisationMembers_OrganisationQueryHookResult = ReturnType<typeof useOrganisationMembers_OrganisationQuery>;
export type OrganisationMembers_OrganisationLazyQueryHookResult = ReturnType<typeof useOrganisationMembers_OrganisationLazyQuery>;
export type OrganisationMembers_OrganisationSuspenseQueryHookResult = ReturnType<typeof useOrganisationMembers_OrganisationSuspenseQuery>;
export type OrganisationMembers_OrganisationQueryResult = Apollo.QueryResult<OrganisationMembers_OrganisationQuery, OrganisationMembers_OrganisationQueryVariables>;
export const OrganisationMembers_MembershipsDocument = gql`
    query OrganisationMembers_Memberships($offset: Int, $limit: Int!, $sorting: [OrganisationMembershipsSorting!]!, $filters: OrganisationMembershipsFilters, $searchTerm: String) {
  organisationMemberships(
    offset: $offset
    limit: $limit
    sorting: $sorting
    filters: $filters
    search: $searchTerm
  ) {
    totalCount
    edges {
      node {
        id
        ...OrganisationMemberRow
      }
    }
  }
}
    ${OrganisationMemberRowFragmentDoc}`;

/**
 * __useOrganisationMembers_MembershipsQuery__
 *
 * To run a query within a React component, call `useOrganisationMembers_MembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMembers_MembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationMembers_MembershipsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useOrganisationMembers_MembershipsQuery(baseOptions: Apollo.QueryHookOptions<OrganisationMembers_MembershipsQuery, OrganisationMembers_MembershipsQueryVariables> & ({ variables: OrganisationMembers_MembershipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationMembers_MembershipsQuery, OrganisationMembers_MembershipsQueryVariables>(OrganisationMembers_MembershipsDocument, options);
      }
export function useOrganisationMembers_MembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationMembers_MembershipsQuery, OrganisationMembers_MembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationMembers_MembershipsQuery, OrganisationMembers_MembershipsQueryVariables>(OrganisationMembers_MembershipsDocument, options);
        }
export function useOrganisationMembers_MembershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationMembers_MembershipsQuery, OrganisationMembers_MembershipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationMembers_MembershipsQuery, OrganisationMembers_MembershipsQueryVariables>(OrganisationMembers_MembershipsDocument, options);
        }
export type OrganisationMembers_MembershipsQueryHookResult = ReturnType<typeof useOrganisationMembers_MembershipsQuery>;
export type OrganisationMembers_MembershipsLazyQueryHookResult = ReturnType<typeof useOrganisationMembers_MembershipsLazyQuery>;
export type OrganisationMembers_MembershipsSuspenseQueryHookResult = ReturnType<typeof useOrganisationMembers_MembershipsSuspenseQuery>;
export type OrganisationMembers_MembershipsQueryResult = Apollo.QueryResult<OrganisationMembers_MembershipsQuery, OrganisationMembers_MembershipsQueryVariables>;
export const OrganisationMembers_CreateNewOrganisationMemberDocument = gql`
    mutation OrganisationMembers_CreateNewOrganisationMember($input: CreateSystemUserInput!) {
  createSystemUser(input: $input) {
    user {
      id
      firstname
      familyname
      email
      roles {
        id
        internalName
      }
    }
  }
}
    `;
export type OrganisationMembers_CreateNewOrganisationMemberMutationFn = Apollo.MutationFunction<OrganisationMembers_CreateNewOrganisationMemberMutation, OrganisationMembers_CreateNewOrganisationMemberMutationVariables>;

/**
 * __useOrganisationMembers_CreateNewOrganisationMemberMutation__
 *
 * To run a mutation, you first call `useOrganisationMembers_CreateNewOrganisationMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMembers_CreateNewOrganisationMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationMembersCreateNewOrganisationMemberMutation, { data, loading, error }] = useOrganisationMembers_CreateNewOrganisationMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationMembers_CreateNewOrganisationMemberMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationMembers_CreateNewOrganisationMemberMutation, OrganisationMembers_CreateNewOrganisationMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationMembers_CreateNewOrganisationMemberMutation, OrganisationMembers_CreateNewOrganisationMemberMutationVariables>(OrganisationMembers_CreateNewOrganisationMemberDocument, options);
      }
export type OrganisationMembers_CreateNewOrganisationMemberMutationHookResult = ReturnType<typeof useOrganisationMembers_CreateNewOrganisationMemberMutation>;
export type OrganisationMembers_CreateNewOrganisationMemberMutationResult = Apollo.MutationResult<OrganisationMembers_CreateNewOrganisationMemberMutation>;
export type OrganisationMembers_CreateNewOrganisationMemberMutationOptions = Apollo.BaseMutationOptions<OrganisationMembers_CreateNewOrganisationMemberMutation, OrganisationMembers_CreateNewOrganisationMemberMutationVariables>;
export const OrganisationMembers_SetMemberAsOrganisationRepresentativeDocument = gql`
    mutation OrganisationMembers_SetMemberAsOrganisationRepresentative($organisationId: ID!, $userId: ID!) {
  setOrganisationRepresentative(
    input: {organisationId: $organisationId, userId: $userId}
  ) {
    organisation {
      id
      representive {
        id
      }
    }
  }
}
    `;
export type OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationFn = Apollo.MutationFunction<OrganisationMembers_SetMemberAsOrganisationRepresentativeMutation, OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationVariables>;

/**
 * __useOrganisationMembers_SetMemberAsOrganisationRepresentativeMutation__
 *
 * To run a mutation, you first call `useOrganisationMembers_SetMemberAsOrganisationRepresentativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMembers_SetMemberAsOrganisationRepresentativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationMembersSetMemberAsOrganisationRepresentativeMutation, { data, loading, error }] = useOrganisationMembers_SetMemberAsOrganisationRepresentativeMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganisationMembers_SetMemberAsOrganisationRepresentativeMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationMembers_SetMemberAsOrganisationRepresentativeMutation, OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationMembers_SetMemberAsOrganisationRepresentativeMutation, OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationVariables>(OrganisationMembers_SetMemberAsOrganisationRepresentativeDocument, options);
      }
export type OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationHookResult = ReturnType<typeof useOrganisationMembers_SetMemberAsOrganisationRepresentativeMutation>;
export type OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationResult = Apollo.MutationResult<OrganisationMembers_SetMemberAsOrganisationRepresentativeMutation>;
export type OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationOptions = Apollo.BaseMutationOptions<OrganisationMembers_SetMemberAsOrganisationRepresentativeMutation, OrganisationMembers_SetMemberAsOrganisationRepresentativeMutationVariables>;